import React, { useState, useEffect, useContext } from 'react';
import api from '../utils/api';
import './styles/TransferInventoryPage.css';
import { useNavigate, useParams } from 'react-router-dom'; 

const StudentProgramEditPage = () => {
    const { studentId } = useParams();
    const [programList, setProgramList] = useState([]);
    const [student, setStudent] = useState('');
    const [levelList, setLevelList] = useState([]);
    const [program, setProgram] = useState('');
    const [level, setLevel] = useState('');
    const [addon, setAddon] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/student/profile/${studentId}`);
                setStudent(response.data.data.student || null);
            } catch (error) {
                console.error("Failed to fetch student details", error);
            }
        };
        fetchStudentDetails();
    }, [studentId]);
    
    useEffect(() => {
        api.get('/utils/getProgramList')
          .then(response => setProgramList(response.data.data.programList))
          .catch(error => console.error('Error fetching program list:', error));
    }, []);

    if (!student) return <p>Loading student details...</p>;

    
    const handleProgramChange = (programId) => {
        api.get(`/utils/getLevelList?program_id=${programId}`)
            .then(response => setLevelList(response.data.data.levelList))
            .catch(error => console.error('Error fetching level list:', error));
        setProgram(programId);
    };

    const handleSubmit = async () => {

        if (program === "") {
            alert('Please fill program option!');
            return;
        }

        if (level === "") {
            alert('Please fill level option!');
            return;
        }

        
        if (addon === "") {
            alert('Please fill add on option!');
            return;
        }

        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }
    
        // Mempersiapkan data untuk dikirim
        const updateProgramData = {
            data: {
                updateProgramData: {
                    student_id: student.student_id, 
                    program_id: program,
                    level_id: level,
                    addon: addon,
                },
            },
        };

        console.log(updateProgramData);
        
    
        try {
            const response = await api.post('/student/program/update', updateProgramData); 
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        } catch (error) {
            console.error('Error submitting data:', error);
            console.error('Error adding/updating student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        }
    };

    return (
        <div className="transfer-inventory-page">
            <div className="page-title">Student Program Update</div>
            <div className="form-container">
                <div className="section">
                    <div className="search-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <label>Student Name</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_name : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Student Code</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student ? student.student_code : ''} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Current Student Program</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].mainProgram.program_name} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Current Student Level</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].Level.level_name} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Add on English Club</label>
                                    </td>
                                    <td>
                                        <div className="input-container">
                                            <input type="text" value={student.StudentLevels[0].addonProgram ? "YES" : "NO"} readOnly />
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>New Program</label>
                                    </td>
                                    <td>
                                        <select value={program} onChange={(e) => handleProgramChange(e.target.value)}>
                                            <option value="">Select Program</option>
                                            {programList.map(program => (
                                                <option key={program.program_id} value={program.program_id}>
                                                    {program.program_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>New Level</label>
                                    </td>
                                    <td>
                                        <select value={level} onChange={(e) => setLevel(e.target.value)}>
                                            <option value="">Select Level</option>
                                            {levelList.map(level => (
                                                <option key={level.level_id} value={level.level_id}>
                                                    {level.level_name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <label>Add On English Club</label>
                                    </td>
                                    <td>
                                        <select value={addon} onChange={(e) => setAddon(e.target.value)}>
                                            <option value="">Select Option</option>
                                            <option value="YES">Yes</option>
                                            <option value="NO">No</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="search-container">
                        <button className="profile-button" onClick={handleSubmit}>Submit</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentProgramEditPage;
